import { render, staticRenderFns } from "./CreateFolderModal.vue?vue&type=template&id=35cea1d5"
import script from "./CreateFolderModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateFolderModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports